exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-item img{max-height:unset!important}.fade-enter{opacity:1}.fade-enter-active{-webkit-transition:opacity .1s ease;transition:opacity .1s ease}.fade-leave{opacity:0}.fade-leave-active{-webkit-transition:opacity .1s ease;transition:opacity .1s ease;opacity:0}", ""]);

// exports
